import React, {useEffect, useRef} from "react";
import {dbtoa, Utils} from "../../../components/audioUtils";
import {VOLUME_UNFOCUSED} from "./videoManager";
import style from "../styles.module.css";
import {Images} from "../../../AssetReferences";

export function GalleryVideo({src, index, loadFullyBeforePlaying = true,  onReadyToPlay, onClick, onHoverStart, onHoverEnd}) {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        
        // load video fully
        try {
            fetch(src).then(response => response.blob()).then(blob => {
                video.src = window.URL.createObjectURL(blob);
            }).then(() => {
                onReadyToPlay?.(video);
            })

        } catch (error) {
            console.error(error);
        }

        // set starting volume
        videoRef.current.volume = dbtoa(VOLUME_UNFOCUSED)

    }, []);
    
    function handleHoverChange(value, keyEvent = false) {
        if (value) {
            onHoverStart?.(videoRef.current);
            if (!keyEvent) {
                videoRef.current.focus();
            }
        } else {
            onHoverEnd?.(videoRef.current);
            if (!keyEvent) {
                videoRef.current.blur();
            }
        }
    }

    function handleKeyUp(event) {
        const key = event.key;
        switch (key) {
            case "Enter":
            case " ":
                onClick?.(videoRef.current);
                break;
        }
    }

    return (
        <div id={"galleryVideo_" + src}>
            <div className={style.gallery_video_container}>
                <video
                    id={"galleryVideo_" + index + "_" + Utils.getFilename(src)}
                    ref={videoRef}
                    className={style.gallery_video}
                    poster={Images.ToiBig}
                    loop={true}

                    onClick={() => onClick?.(videoRef.current)}
                    onKeyUp={handleKeyUp}

                    onContextMenu={(evt) => evt.preventDefault()} // prevents right clicks

                    style={{
                        opacity: 0,
                        pointerEvents: "none",
                    }}
                    
    
                    onFocus={() => handleHoverChange(true, true)}
                    onBlur={() => handleHoverChange(false, true)}
                    onMouseEnter={() => handleHoverChange(true)}
                    onMouseLeave={() => handleHoverChange(false)}
                >
                    <source src='' type="video/mp4"/>
                </video>
            </div>
        </div>
    )
}